const updateHash = color => {
  if (global !== undefined) {
    global.location.hash = `#${color}`
  }
}

export default state => ({
  fn: updateHash,
  args: [state.get('color')],
})



// WEBPACK FOOTER //
// ./heats/hash.js